import {
  FacebookLandingPage,
  HomePage,
  //Avista Flow
  AvistaHomePage,
  //CreditPage
  CreditPage,
  AcuotasPage,
  NosotrosPage,
  NotFoundPage,
  FaqsPage,
  ContactPage,
  RatesPage,
  TermsPage,
  DataPage,
  TratamientoDatosRedirectPage,
  FisicoPage,
  RequisitosPage,
  ComoFuncionaPage,
  SignupPage,
  SigninPage,
  VerificationEmailPage,
  VerificationPage,
  PreaprobadoPage,
  CrezuPage,
  ErrorPage,
  FirmaPage,
  ConfirmadoPage,
  ProfilePage,
  MyCreditPage,
  MethodsPage,
  CashOptionsPage,
  CashPayPage,
  CashPayEfectyPage,
  CashPayWUPage,
  ExtendPage,
  CreditDetailPage,
  BancoPage,
  RenovarPage,
  IndexBlogPage,
  AumentarCupoPage,
  MejorarPuntajePage,
  PorQueNegaronPage,
  ComoConstruirPage,
  NConsejosParaPage,
  AppsPage,
  VeriffPage,
  VeriffStatusPage,
} from "./pages";

import { Routes, Route } from "react-router-dom";
// Navbars
import { NavbarHome } from "./components/navigation/NavbarHome";
import { NavbarIndex } from "./components/navigation/NavbarIndex";
import { NavbarLogin } from "./components/navigation/NavbarLogin";
import { SimpleNavbar } from "./components/navigation/SimpleNavbar";
// Footers
import { Footer } from "./components/navigation/Footer";

import { CreditProvider } from "./context/creditContext";
import { useNavigate } from "react-router-dom";
//CONTEXT
import { TokenState } from "./context/Auth/AuthState";
import { CreditUserState } from "./context/CreditUser/CreditUserState";
import { FormOneState } from "./context/FormOne/FormOneState";
import { FormTwoState } from "./context/FormTwo/FormTwoState";
import { OfertaViewState } from "./context/OfertaContext/OfertaViewState";
import "./index.css";
import { CashPayPageExtend } from "./pages/dashboard/pagos/CashPayPageExtend";
import { VerificationPhonePage } from "./pages/autentication/VerificationPhonePage";
import { validateSessionAndJwtToken } from "./utils/validateTokenSession";
import { InactivityProvider } from "./providers/session/inactivityProvider";
import { returnToSignin } from "./utils/returnToSign";
import { FriendsViewState } from "./context/Disclosures/friends/friendsState";
import { NotificationsState } from "./context/Disclosures/notifications/notificationsState";
import { RewardsViewState } from "./context/Disclosures/rewards/rewardsState";
import { LevelCustomerPage } from "./pages/dashboard/profile/LevelCustomerPage";
import { CreditoPage } from "./pages/flujo/nuevo_formulario/CreditoPage";
import { NewPayLoginPage } from "./pages/dashboard/pagos/NewPayLoginPage";
import { NewMethodsPage } from "./pages/dashboard/pagos/NewMethodsPage";
import { NewCashPayPage } from "./pages/dashboard/pagos/NewCashPayPage";
import { NewPayAbonoPage } from "./pages/dashboard/pagos/NewPayAbonoPage";
import { RenovarCreditoPage } from "./pages/flujo/nuevo_formulario/flowRenovarCredit/RenovarCreditoPage";
import UmamiIdentify from "./components/umami/UmamiIdentify";
import AttributionTracker from "./components/attribution/AttributionTracker";
import AnalyticsClickTracker from "./components/analytics/AnalyticsClickTracker";
import SentryUserSync from "./components/sentry/SentryUserSync";

function App() {
  let navigate = useNavigate();

  const validaToken = async () => {
    setInterval(async () => {
      const isSignin = localStorage.getItem("is_signin");
      if (isSignin === true || isSignin === "true") {
        let isValidToken = await validateSessionAndJwtToken();
        if (!isValidToken) {
          returnToSignin(navigate);
        }
      }
    }, 1200000);
  };

  validaToken();

  return (
    <div className="font-walsheim text-tdark tracking-tight">
      <div >
        <TokenState>
          <FormOneState>
            <FormTwoState>
              <CreditUserState>
                <OfertaViewState>

                  {/* Start Avista flow area*/}

                  <FriendsViewState>
                    <NotificationsState>
                      <RewardsViewState>
                        {/*   <ChatProvider> */}
                        {/*        <ChatBot /> */}
                        <AttributionTracker />
                        <AnalyticsClickTracker />
                        <UmamiIdentify />
                        <SentryUserSync />
                        <Routes>
                          <Route
                            exact
                            path="/credito-pensionados"
                            element={
                              <div>
                                <SimpleNavbar />
                                <AvistaHomePage />
                              </div>
                            }
                          />

                          {/* Start Facebook Landing area*/}
                          <Route
                            exact
                            path="/facebook-ads"
                            element={
                              <div>
                                <NavbarHome />
                                <FacebookLandingPage />
                                <Footer />
                              </div>
                            }
                          />

                          {/* Start Home area*/}
                          <Route
                            exact
                            path="/"
                            element={
                              <div>
                                <NavbarIndex current1={true} />
                                <HomePage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            exact
                            path="/creditos"
                            element={
                              <div>
                                <NavbarHome current1={true} />
                                <CreditPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            exact
                            path="/a-cuotas"
                            element={
                              <div>
                                <NavbarHome current1={true} />
                                <AcuotasPage />
                                <Footer />
                              </div>
                            }
                          />

                          <Route
                            path="/nosotros"
                            element={
                              <div>
                                <NavbarHome current2={true} />
                                <NosotrosPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/tarifas"
                            element={
                              <div>
                                <NavbarHome current3={true} />
                                <RatesPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/faqs"
                            element={
                              <div>
                                <NavbarHome current5={true} />
                                <FaqsPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/contactanos"
                            element={
                              <div>
                                <NavbarHome />
                                <ContactPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/terminos"
                            element={
                              <div>
                                <NavbarHome />
                                <TermsPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/datos"
                            element={
                              <div>
                                <NavbarHome />
                                <DataPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/tratamiento-datos"
                            element={<TratamientoDatosRedirectPage />}
                          />
                          <Route
                            path="/fisico"
                            element={
                              <div>
                                <NavbarHome />
                                <FisicoPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/requisitos"
                            element={
                              <div>
                                <NavbarHome current6={true} />
                                <RequisitosPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/como-funciona"
                            element={
                              <div>
                                <NavbarHome />
                                <ComoFuncionaPage />
                                <Footer />
                              </div>
                            }
                          />
                          {/* End Home area*/}

                          {/* Start Blog area */}
                          <Route
                            path="/blog"
                            element={
                              <div>
                                <NavbarHome />
                                <IndexBlogPage />
                                <Footer />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/como-aumentar-mi-cupo-de-credito"
                            element={
                              <div>
                                <NavbarHome /> <AumentarCupoPage />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/por-que-galilea-nego-mi-solicitud"
                            element={
                              <div>
                                <NavbarHome /> <PorQueNegaronPage />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/como-mejorar-mi-puntaje-en-datacredito"
                            element={
                              <div>
                                <NavbarHome /> <MejorarPuntajePage />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/6-consejos-para-manejar-tus-finanzas"
                            element={
                              <div>
                                <NavbarHome /> <NConsejosParaPage />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/como-construir-historial-crediticio"
                            element={
                              <div>
                                <NavbarHome /> <ComoConstruirPage />
                              </div>
                            }
                          />
                          <Route
                            path="/blog/4-apps-para-llevar-un-registro-financiero"
                            element={
                              <div>
                                <NavbarHome /> <AppsPage />
                              </div>
                            }
                          />

                          {/* End Blog area */}

                          {/* Start Not Found area*/}
                          <Route
                            path="*"
                            element={
                              <div>
                                <NotFoundPage />
                              </div>
                            }
                          />
                          {/* End Not Found area*/}

                          {/* Start login area */}

                          <Route path="/registrarse" element={<SignupPage />} />
                          <Route path="/ingresar" element={<SigninPage />} />
                          <Route
                            path="/autenticarse-email"
                            element={<VerificationEmailPage />}
                          />
                          <Route
                            path="/autenticarse"
                            element={<VerificationPage />}
                          />

                          <Route
                            path="/validate-phone"
                            element={<VerificationPhonePage />}
                          />

                          {/* End login area */}

                          {/* Start Flujo area */}

                          {/* <Route
                            path="/formulariouno"
                            element={
                              <div>
                                <NavbarLogin /> <FormulariounoPage />
                              </div>
                            }
                          /> */}

                          {/* <Route
                            path="/formulariodos"
                            element={
                              <div>
                                <NavbarLogin /> <FormulariodosPage />
                              </div>
                            }
                          /> */}

                          <Route
                            path="/request-credit-beta"
                            element={
                              <div >
                                {/* <NavbarLogin /> */}
                                <CreditoPage />
                              </div>
                            }
                          />
                          <Route
                            path="/request-credit"
                            element={
                              <div >
                                {/* <NavbarLogin /> */}
                                <CreditoPage />
                              </div>
                            }
                          />

                          <Route
                            path="/preaprobado"
                            element={
                              <div>
                                <NavbarLogin /> <PreaprobadoPage />
                              </div>
                            }
                          />

                          <Route
                            path="/oferta"
                            element={
                              <div>
                                <OfertaViewState>
                                  {/* <NavbarLogin />  */}
                                  <RenovarCreditoPage />
                                </OfertaViewState>
                              </div>
                            }
                          />

                          <Route
                            path="/negado"
                            element={
                              <div>
                                <NavbarLogin /> <CrezuPage />
                              </div>
                            }
                          />
                          <Route
                            path="/error"
                            element={
                              <div>
                                <NavbarLogin /> <ErrorPage />
                              </div>
                            }
                          />
                         {/*  <Route
                            path="/contrato"
                            element={
                              <div>
                                <NavbarLogin /> <ContratoPage />
                              </div>
                            }
                          />
                          <Route
                            path="/pagare"
                            element={
                              <div>
                                <NavbarLogin /> <PagarePage />
                              </div>
                            }
                          /> */}
                          <Route
                            path="/firma"
                            element={
                              <div>
                                <NavbarLogin /> <FirmaPage />
                              </div>
                            }
                          />
                          <Route
                            path="/confirmado"
                            element={
                              <div>
                                <NavbarLogin /> <ConfirmadoPage />
                              </div>
                            }
                          />

                          {/* End Flujo area */}

                          {/* Dashboard Usuario */}

                          <Route
                            path="/perfil"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <ProfilePage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/nivel-cliente"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <LevelCustomerPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/mis-bancos"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <BancoPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/micredito"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <MyCreditPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/detalle-credito"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <CreditDetailPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          {/* <Route
                            path="/pagar2"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <PayLoginPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          /> */}
                          <Route
                            path="/pagar"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <NewPayLoginPage />{" "}
                                  {/* <PayLoginPage />{" "} */}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/abonar"
                            element={
                              <InactivityProvider>
                                {" "}
                                <CreditProvider>
                                  {" "}
                                  <NewPayAbonoPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/extencion"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <ExtendPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/medios-de-pago2"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <MethodsPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/medios-de-pago"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <NewMethodsPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/opciones-efectivo"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <CashOptionsPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/pago-efectivo"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <CashPayPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/referencia-efectivo"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <NewCashPayPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/pago-efectivo-efecty"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <CashPayEfectyPage />{" "}
                                </CreditProvider>{" "}
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/pago-efectivo-wu"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <CashPayWUPage />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/pago-efectivo-extend"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <CashPayPageExtend />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/renovar"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <RenovarPage />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          />
                          {/* <Route
                            path="/renovar/confirmar"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  {" "}
                                  <ConfirmarPage />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          /> */}
                          <Route
                            path="/veriff"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  <VeriffPage />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          />
                          <Route
                            path="/veriff-status"
                            element={
                              <InactivityProvider>
                                <CreditProvider>
                                  <VeriffStatusPage />
                                </CreditProvider>
                              </InactivityProvider>
                            }
                          />
                          {/* Enlace público de verificación (sin sesión), enviado por ej. desde WhatsApp/n8n */}
                          <Route
                            path="/veriff/:token"
                            element={
                              <CreditProvider>
                                <NavbarLogin />
                                <VeriffPage />
                              </CreditProvider>
                            }
                          />
                          <Route
                            path="/veriff-status/:token"
                            element={
                              <CreditProvider>
                                <NavbarLogin />
                                <VeriffStatusPage />
                              </CreditProvider>
                            }
                          />
                          {/* End Flujo Dashboard Usuario */}
                        </Routes>
                        {/*  </ChatProvider> */}
                      </RewardsViewState>
                    </NotificationsState>
                  </FriendsViewState>
                </OfertaViewState>
              </CreditUserState>
            </FormTwoState>
          </FormOneState>
        </TokenState>
      </div>
    </div >
  );
}

export default App;
